import { render, staticRenderFns } from "./Locator.vue?vue&type=template&id=05d212f6&scoped=true"
import script from "./Locator.vue?vue&type=script&lang=js"
export * from "./Locator.vue?vue&type=script&lang=js"
import style0 from "./Locator.vue?vue&type=style&index=0&id=05d212f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d212f6",
  null
  
)

export default component.exports